import api from '../services/api';

/**
 * Descarga una imagen de la API y la devuelve como data URI.
 *
 * El informe no puede apoyarse en `<img src="/api/imagenes/ver/...">`: al
 * imprimir, el navegador abre una ventana nueva y no espera a que las imágenes
 * externas terminen de bajar, así que la firma y el logo salían en blanco.
 * Incrustadas en el documento van sí o sí.
 *
 * Devuelve null cuando el archivo no está en el servidor, para poder avisarlo
 * en lugar de dejar un hueco sin explicación.
 */
export const cargarImagenComoDataUri = async (nombre?: string | null): Promise<string | null> => {
  const archivo = (nombre || '').trim().replace(/^\/+/, '');
  if (archivo === '' || archivo === 'no especifica.png') return null;

  try {
    const respuesta = await api.get(`/imagenes/ver/${archivo}`, { responseType: 'blob' });
    const contenido: Blob = respuesta.data;
    if (!contenido || contenido.size === 0) return null;

    return await new Promise<string | null>(resolve => {
      const lector = new FileReader();
      lector.onloadend = () => resolve(typeof lector.result === 'string' ? lector.result : null);
      lector.onerror = () => resolve(null);
      lector.readAsDataURL(contenido);
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(`No se pudo cargar la imagen "${archivo}":`, error);
    return null;
  }
};
